export default __webpack_public_path__ + "static/media/3.cf199691.jpeg";